export default __webpack_public_path__ + "static/highlight-feedback-focus-a1ced1bea0e043f23f5b106adef25053.webp";